'use client';

import { createContext } from 'react';

import type { TooltipFloatingContextInterface } from '../types/use-tooltip.types';

export const TooltipFloatingContext = createContext({} as TooltipFloatingContextInterface);

TooltipFloatingContext.displayName = 'Tooltip.Floating.Context';
